// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#error-wrapper[data-v-671a543e] {\n    margin: 0 auto;\n    max-width: 250px;\n}\n#error-img-wrapper[data-v-671a543e] {\n    padding-left: 10px;\n}\n#error-img[data-v-671a543e] {\n    margin: 40px auto;\n}\n#error-title[data-v-671a543e] {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n#error-text[data-v-671a543e] {\n    margin-bottom: 80px;\n}\n#error-code[data-v-671a543e] {\n    color: #bbbbbb;\n    font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
